<template>
  <div class="search-page">
    <div :class="['search-banner',addressHover]"
         @mouseleave="addressLeave()" :style="(topItem&&topItem.typeImg?'backgroundImage:url('+topItem.typeImg+');':'')">
      <div class="" :class="['posRe animated zoomIn', (params.typeId == 0?'address-left':'')]">
        <div v-if="params.typeId != 0">
          <h3>{{topItem.name}}</h3>
          <p>{{topItem.ename}}</p>
        </div>
        <div class="father-address">
          <div class="next-prev-btn next-prev-right  next-prev-right1"></div>
          <div class="next-prev-btn next-prev-left next-prev-left1"></div>
          <div class="swiper-container container-address">
            <div class="swiper-wrapper">
              <div class="swiper-slide" :class="[addressActive==0 ||addressHoverActive==0?'active':'']"
                   @mouseover="addressOver()"
                   @mouseleave="countyLeave()"
                   @click="addressBtn(cityAllId)"
              >
                <div class=""><span>全部</span></div>
              </div>
              <template v-if="addressLists&&addressLists.length">
                <template v-for="(list, i) in addressLists">
                  <div class="swiper-slide"
                       :class="[addressActive==(i+1)||addressHoverActive==(i+1)?'active':'']"
                       :key="'addressLists'+i"
                       @mouseover="addressOver(i)"
                       @click="addressBtn(list.cityId,i)"
                  >
                    <div class=""><span>{{list.name}}</span></div>
                    <span class="san" v-if="addressHoverActive==(i+1)&&countyAddress&&countyAddress.length"></span>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
        <div class="search-search" @mouseover="inputSearchOver">
          <input :class="[searchKeyValClass]" type="text" v-model="searchKeyVal" @keyup.enter="keySearchBtn" placeholder="搜索关键字" />
          <span class="icon-img icon-search" @click="keySearchBtn"></span>
        </div>
      </div>
      <div class="search-county" v-if="countyAddress&&countyAddress.length">
        <div class="next-prev-btn next-prev-right next-prev-right2"></div>
        <div class="next-prev-btn next-prev-left next-prev-left2"></div>
        <div class="swiper-container container-county">
          <div class="swiper-wrapper">
            <div class="swiper-slide" :class="[countyActive==0||countyHoverActive==0?'active':'']"
                 @mouseover="countyOver()"
                 @click="countyBtn(addressId)">
              <div class=""><span>全部</span></div>
            </div>
            <template v-if="countyAddress&&countyAddress.length">
              <template v-for="(county, i) in countyAddress">
                <div class="swiper-slide" :class="[(addressHoverActive==addressActive&&countyActive==(i+1))||countyHoverActive==(i+1)?'active':'']" :key="'search-county'+i"
                     @mouseover="countyOver(i)"
                     @click="countyBtn(county.cityId,i)"
                >
                  <div class=""><span>{{county.name}}</span></div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <template v-if="lists&&lists.length">
      <div class="clearFloat marTop jump-position animated fadeInUp" :class="[client==3?'':'clearFloat-4']">
        <template v-for="(item, index) in lists">
          <only-list :item="item" :class-name="'search'+index" :lazy="lazy" :key="'search-list'+index"></only-list>
        </template>
        <template v-if="total<8&&oldcityId!=1">
          <template v-for="defaultIndex in (8-total)">
            <only-list default-bool="true" :item="defaultData" :lazy="lazy" :class-name="'search'+defaultIndex"  :key="'search-list'+(8-defaultIndex)"></only-list>
          </template>
        </template>
      </div>
      <zpagenav v-if="total>16" class="animated fadeInUp" :page="page" :page-size="pageSize" :total="total" :max-link="maxLink" :page-handler="pageHandler" :event-name="eventName"></zpagenav>
    </template>
    <template v-else>
      <div v-if="oldcityId!=1" class="clearFloat marTop jump-position animated fadeInUp" :class="[client==3?'':'clearFloat-4']">
        <template v-for="defaultIndex in 8">
          <only-list default-bool="true" :item="defaultData" :lazy="lazy" :class-name="'search'+defaultIndex"  :key="'search-list'+defaultIndex"></only-list>
        </template>
      </div>
      <div v-if="oldcityId==1" class="marTop no-data-text animated bounceIn">
        <div class="no-data"></div>
        <p>暂无<span v-if="searchKeyVal"> {{searchKeyVal}} 的</span>相关内容</p>
      </div>
    </template>
  </div>
</template>
<script>
import onlyList from '@/components/onlyList'
import zpagenav from '@/components/zpagenav'
export default {
  name: 'searchPage',
  props: ['client'],
  data () {
    return {
      activeIndex: 0,
      searchBool: false,
      lists: [],
      params: {
        page: 1,
        limit: 16,
        cityId: 0,
        typeId: 0,
        keyWords: '',
        '_': new Date().getTime()
      },
      lazy: {
        bool: false
      },
      page: 1,
      pageSize: 16,
      total: 0,
      eventName: 'custom',
      maxLink: 5,
      searchKeyVal: '',
      searchKeyValClass: '',
      addressLists: [],
      countyAddress: [],
      addressActive: 0,
      countyActive: 0,
      addressHoverActive: '',
      countyHoverActive: '',
      addressHover: '',
      addressId: 0,
      cityAllId: 0,
      topItem: {},
      swiperObjAddress: '',
      swiperObjCounty: '',

      defaultData:{
        address: '',
        cityName: '',
        good: "",
        id: 0,
        imgSrc: "",
        name: "",
        panoUrl: "",
        phone: "",
        share:'',
        x: "",
        y: "",
      },
      oldcityId:''
    }
  },
  components: {
    onlyList: onlyList,
    zpagenav: zpagenav
  },
  mounted () {
  },
  created () {
    let that = this
    that.clientFun()
    let routeQuery = JSON.parse(that.publicJs.decode(this.$route.query)) || {}
    that.params.typeId = routeQuery.typeId || 0;
    that.params.keyWords = routeQuery.keyWords || '';
    that.searchKeyVal = routeQuery.keyWords || '';
    that.params.cityId = routeQuery.cityId || 0;
    that.oldcityId = routeQuery.cityId || 0;
    that.addressData()
    that.httpData()
    that.$emit('topState', 1);
    that.publicJs.navGetData(function (data) {
      if (data.code === 1) {
        that.topItem = that.publicJs.onlyTypeData(data.data,routeQuery.typeId)
      }
    })
  },
  methods: {
    clientFun: function () {
      let that = this
      if (that.client === 1) {
        that.params.limit = 20
        that.pageSize = 20
      } else if (that.client === 2) {
        that.params.limit = 9
        that.pageSize = 9
      } else if (that.client === 3) {
        that.params.limit = 12
        that.pageSize = 12
      } else {
        that.params.limit = 16
      }
    },
    newList: function (ArrayList, n) {
      if (ArrayList.length && n > 0) {
        let newArray = []
        let num = Math.ceil(ArrayList.length / n)
        for (let i = 0; i < num; i++) {
          newArray.push(ArrayList.splice(0, n))
        }
        return newArray
      }
    },
    httpData: function () {
      let _that = this
      _that.httpAjax.getAjax('PanoWebService.asmx/GetPanoByWhere', _that.params).then(function (data) {
        if (data.code === 1) {
          _that.total = data.total;
          const search = _that.searchKeyVal;
          if (search) {
            _that.lists = data.data.map(item => {
              let replaceReg = new RegExp(search, 'g'); // 匹配关键字正则
              let replaceString = '<span style="color:red;">' + search + '</span>' // 高亮替换v-html值
              item.name = item.name.replace(replaceReg, replaceString) // 开始替换
              return item
            })
          } else {
            _that.lists = data.data
          }
        }
      }, function (err) {
        console.log(err)
      })
    },
    pageHandler: function (page) {
      this.page = Number(page);
      this.params.page = Number(page)
    },
    addressData: function () {
      let that = this;
      this.publicJs.addressGetData(function (res) {
        if (res.code === 1) {
          let routQuery = JSON.parse(that.publicJs.decode(that.$route.query));
          let city=that.publicJs.onlyCityData(res.data,routQuery.cityId);

          that.publicJs.changeDocumentTitle(city.name,routQuery.cityId);
          if(city.data){
            that.addressLists=city.data;
          }else {
            that.addressLists=city?city.child:res.data;
          }
          that.cityAllId = (routQuery.cityId||0);

          that.$nextTick(function () {
            that.swiperObjAddress = new Swiper('.container-address', {
              slidesPerView: 'auto',
              spaceBetween: 15,
              observer: true,
              observeSlideChildren: true,
              observeParents: true,
              watchOverflow: true,
              navigation: {
                nextEl: '.next-prev-right1',
                prevEl: '.next-prev-left1'
              },
              breakpoints: {
                1200: {
                  spaceBetween: 10
                },
                750: {
                  spaceBetween: 5
                }
              }
            })
          })
        }
      })
    },
    inputSearchOver: function () {
      this.addressLeave()
    },
    addressOver: function (i) {
      let that = this;
      that.addressHover = 'address-hover';
      that.countyHoverActive = -1;
      if (i >= 0) {
        that.countyAddress = that.addressLists[i].child;
        that.addressId = that.addressLists[i].cityId;
        this.addressHoverActive = i + 1;
        that.$nextTick(function () {
          that.swiperObjCounty = new Swiper('.container-county', {
            slidesPerView: 'auto',
            spaceBetween: 15,
            observer: true,
            observeSlideChildren: true,
            observeParents: true,
            watchOverflow: true,
            navigation: {
              nextEl: '.next-prev-right2',
              prevEl: '.next-prev-left2'
            },
            breakpoints: {
              1200: {
                spaceBetween: 10
              },
              750: {
                spaceBetween: 5
              }
            }
          })
        })
      } else {
        that.addressId = 0;
        that.countyAddress = [];
        that.addressHoverActive = 0
      }
    },
    addressLeave: function () {
      let that = this;
      that.countyAddress = [];
      that.addressHoverActive = -1;
      that.addressHover = ''
    },
    addressBtn: function (cityId, i) {
      this.params.page = 1;
      this.page = 1;
      this.params.cityId = cityId;
      this.params.keyWords = this.searchKeyVal;
      if (i >= 0) {
        this.addressActive = i + 1;
        this.countyActive = 0
      } else {
        this.addressActive = 0
      }
      this.swiperObjAddress.slideTo(this.addressActive - 1)
    },
    countyOver: function (i) {
      let that = this;
      that.addressHover = 'address-hover';
      if (i >= 0) {
        this.countyHoverActive = i + 1
      } else {
        that.countyHoverActive = 0
      }
    },
    countyLeave: function (i) {
      let that = this
      that.countyHoverActive = -1;
      that.addressHover = ''
    },
    countyBtn: function (cityId, i) {
      this.params.page = 1;
      this.page = 1;
      this.params.cityId = cityId;
      this.params.keyWords = this.searchKeyVal;
      if (i >= 0) {
        this.addressActive = this.addressHoverActive;
        this.countyActive = i + 1
      } else {
        this.countyActive = 0
      }
    },
    keySearchBtn: function () {
      let that = this
      that.$emit('searchKeyVal', that.searchKeyVal);
      that.params.keyWords = that.searchKeyVal;
      if (!that.searchKeyVal) {
        that.searchKeyValClass = 'no-search-key-val';
        setTimeout(function () {
          that.searchKeyValClass = ''
        }, 2000)
      }
    }
  },
  watch: {
    params: {
      handler: function (a, b) {
        this.httpData()
      },
      deep: true
    },
    client: {
      handler: function (a, b) {
        let that = this;
        if (a !== b) {
          that.lists = [];
          that.params.page = 1;
          that.page = 1;
          that.clientFun();
          that.httpData()
        }
      },
      deep: true
    },
    '$route': function (a, b) {
      if (a !== b) {
        let routeQuery = JSON.parse(this.publicJs.decode(this.$route.query)) || {};
        this.params.typeId = routeQuery.typeId || 0;
        this.params.keyWords = routeQuery.keyWords || '';
        this.params.cityId = routeQuery.cityId || 0;
        this.searchKeyVal = routeQuery.keyWords;
        this.addressActive = 0;
        this.countyActive = 0
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .search-page{
    padding: 80px 20px;
    overflow: hidden;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .screen2 .search-page{
    padding: 80px 10px;
  }
  .screen3 .search-page{
    padding: 80px 10px;
  }
  .marTop{
    margin-top: 25px;
  }
  .screen2 .marTop,.screen3 .marTop{
    margin-top: 30px;
  }
  .content-center{
    padding: 30px 20px 96px;
  }
  .search-banner{
    padding: 24px 50px;
    border-radius: 8px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.1;
    background: #645c5d url("../../../static/images/bei.jpg") no-repeat top center;
    background-size: cover;
    color: white;
    text-transform: capitalize;
    position: relative;
    height: 90px;
  }
  .screen2 .search-banner{
    padding: 15px 25px;
    height: 72px;
  }
  .screen3 .search-banner {
    padding: 15px 20px;
    height: 72px;
  }
  .search-banner h3{
    font-size: 24px;
    height: 25px;
  }
  .search-banner p{
    font-size: 16px;
    height: 17px;
    margin-top: 3px;
  }
  .father-address{
    position: absolute;
    top:10px;
    right: 262px;
    display: flex;
    align-items: center;
    max-width: 430px;
    padding: 0 25px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
  }
  .next-prev-btn{
    position: absolute;
    width: 20px;
    height: 20px;
    top:4px;
    background-repeat: no-repeat;
    background-size: 75%;
    background-position: center;
    cursor: pointer;
  }
  .search-county .next-prev-btn{
    top:27px;
  }
  .next-prev-btn.swiper-button-disabled{
    opacity: 0;
  }
  .father-address .next-prev-left{
    left: 0;
  }
  .father-address .next-prev-right{
    right: 0;
  }
  .search-county .next-prev-left{
    left: 8px;
  }
  .search-county .next-prev-right{
    right: 8px;
  }
  .screen2 .father-address{
    right: 210px;
    max-width: 400px;
  }
  .father-address .swiper-slide,
  .container-county .swiper-slide{
    width: auto;
  }
  .container-county .swiper-slide>div,
  .father-address .swiper-slide>div{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 3px 14px;
    line-height: 1.2;
    border-radius: 4px;
  }
  .container-county .active>div,
  .father-address .active>div{
    position: relative;
  }
  .container-county .swiper-slide span,
  .father-address .swiper-slide span{
    position: relative;
    z-index: 3;
  }
  .container-county .swiper-slide>div::after,
  .father-address .swiper-slide>div::after{
    content: '';
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    bottom: 0;
    -webkit-transform: scaleX(0);
    -moz-transform: scaleX(0);
    -ms-transform: scaleX(0);
    -o-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: -webkit-transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    transition: -webkit-transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    -o-transition: transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    transition: transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    -webkit-transform-origin: top left;
    -ms-transform-origin: top left;
    transform-origin: top left;
  }
  .container-county .active>div::after,
  .father-address .active>div::after{
    -webkit-transform: scaleX(1);
    -moz-transform: scaleX(1);
    -ms-transform: scaleX(1);
    -o-transform: scaleX(1);
    transform: scaleX(1);
    background-color: #248DDF;
    -webkit-transition: -webkit-transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    transition: -webkit-transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    -o-transition: transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    transition: transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    -webkit-transform-origin: top left;
    -ms-transform-origin: top left;
    transform-origin: top left;
  }

  .container-county .swiper-slide{
    color:#666666;
  }
  .container-county .active>div{
    color: #fff;
  }
  .father-address .swiper-slide{
    padding-bottom: 28px;
  }
  .screen2 .father-address .swiper-slide,
  .screen3 .father-address .swiper-slide{
    padding-bottom: 22px;
  }
  .screen2 .search-county .next-prev-btn{
    top: 18px;
  }
  .screen2 .search-county .next-prev-right{
    right: 5px;
  }
  .screen2 .search-county .next-prev-left{
    left: 5px;
  }
  .screen2 .search-county,.screen3 .search-county {
    top: 72px;
    padding: 15px 25px;
    z-index: 5;
  }
  .father-address .active .san{
    position: absolute;
    width: 0;
    height: 0;
    bottom: 0;
    left: 50%;
    margin-left: -10px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
  }
  .search-search{
    position: absolute;
    top:0;
    right: 0;
    bottom: 0;
    width: 200px;
    height: 40px;
    border: 1px solid #E4E4E4;
    border-radius: 6px;
    font-size: 14px;
    color: #E4E4E4;
    padding: 0 14px 0 9px;
  }
  .search-search input{
    height: 100%;
    color: white;
  }
  .icon-search{
    background-position:-426px -229px;
    width: 20px;
    height: 22px;
    position: absolute;
    top: 50%;
    margin-top: -11px;
    right: 14px;
    cursor: pointer;
  }
  .search-county{
    position: absolute;
    right: 0;
    background: white;
    left: 0;
    top: 87px;
    padding:25px 30px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 8px;
    -webkit-box-shadow:3px 4px 8px 0 rgb(213 213 213);
    -moz-box-shadow:3px 4px 8px 0 rgb(213 213 213);
    box-shadow:3px 4px 8px 0 rgb(213 213 213);
    z-index: 100;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
  }
  @keyframes yi {
    0%{
      -webkit-transform: scaleY(0);
      -moz-transform: scaleY(0);
      -ms-transform: scaleY(0);
      -o-transform: scaleY(0);
      transform: scaleY(0);
    }
    100%{
      -webkit-transform: scaleY(1);
      -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
  .address-hover .search-county{
    -webkit-animation: yi 0.5s;
    -o-animation: yi 0.5s;
    animation: yi 0.5s;
    -webkit-transform-origin: top left;
    -ms-transform-origin: top left;
    transform-origin: top left;
  }
  >>>.address-left .father-address{
    left: 0;
    top:10px;
    width: 50%;
  }
  >>>.no-search-key-val{
    font-size: 16px;
    letter-spacing: 1px;
    -webkit-animation: fontSizeAnimate 0.8s 2;
    -o-animation: fontSizeAnimate 0.8s 2;
    animation: fontSizeAnimate 0.8s 2;
  }
  >>>.no-search-key-val::-webkit-input-placeholder{
    color: white;
  }
  @keyframes fontSizeAnimate {
    0%{
      opacity: 0;
    }
    50%{
      opacity: 1;
    }
    100%{
      opacity: 0;
    }
  }
  .no-data{
    height: 400px;
  }

  .screen1 .clearFloat-4>div{
    width: 19%;
  }
  .screen2 .clearFloat-4>div{
    width: 32.33%;
  }
  .screen3 .clearFloat>div{
    width: 50%;
    float: left;
  }
  .screen2 .search-search,.screen3 .search-search{
    width: 170px;
    top: 3px;
    right: -6px;
    height: 34px;
    padding: 0 11px 0 4px;
  }
  .screen3 .father-address{
    left: 180px;
    right: 200px;
  }
  @media (max-width:900px) {
    .screen2 .father-address{
      left: 180px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/searchPage/index.vue